import React, { useState, useEffect } from 'react';
import apiImage01 from '../../images/guide/img_api_01.png';
import apiImage02 from '../../images/guide/img_api_02.png';
import apiImageSet from '../../images/guide/img_set.png';
import { useForm } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import { gql, useMutation, useReactiveVar } from '@apollo/client';
import sweetAlert from 'sweetalert2';
import { addjobMutation, addjobMutationVariables } from './dtos/addjobMutation';
import Swal from 'sweetalert2';
import { isLoggedInVar } from '../../apollo';
import io from 'socket.io-client';

// mutation addjobMutation($addjobInput: AddjobInput!)이 줄은 모두 frontend만을 위한거다
// mutation 뒤의 이름은 Front에서만 확인하는 변수다. $뒤에 입력하는 이름은 아폴로에게 알려주는 변수명이다.
// playground에 입력하는대로 그대로 적으면 된다.
const ADDJOB_MUTATION = gql`
    mutation addjobMutation($addjobInput: AddjobInput!) {
        addjob(input: $addjobInput) {
            success
            message
            job_id
        }
    }
`;

//interface는 I로 시작하게 하면 직관적으로 알 수 있다.
interface IAddjobForm {
    shopId: string;
    shopPw: string;
    prodName: string;
}

function PlayApiGuide({ location }: any) {
    const isLoggedIn = useReactiveVar(isLoggedInVar);
    const [check, setCheck] = React.useState(0);
    const history = useHistory();
    const { register, watch, errors, handleSubmit, getValues } = useForm<IAddjobForm>();
    //console.log(watch('email')); //ref={register}로 등록해주면 email 이라는 input name의 Element를 관찰합니다.
    //Email 란에 입력하는대로 console.log가 열심히 찍힘 (ex:비밀번호 몇자이상 등 유효성 검사를 위해 watch를 해야함)

    //backend socket
    const [jobId, setJobId] = useState('');
    const [jobResultMsg, setJobResultMsg] = useState('');
    const [jobStateMsg, setJobStateMsg] = useState('');

    // 스크롤 이벤트 최초 실행
    useEffect(() => {
        //console.log(location);
        if (location.state?.scrollTargetId) {
            scrollEvent(location.state.scrollTargetId);
        }
    }, []);

    // useEffect(() => {
    //     if (jobId != '') {
    //         const sockets = io(playApiEndPoint, {
    //             query: { jobId: jobId },
    //             transports: ['websocket'],
    //         });
    //         console.log(sockets);
    //         // 상품수집 완료
    //         sockets.on('progress', (payload: any) => {
    //             // 결과 응답일 경우
    //             if ('result' in payload) {
    //                 if (payload.result === '') {
    //                     setJobResultMsg('상품수정 성공');
    //                 } else {
    //                     setJobResultMsg(payload.result);
    //                 }
    //             } else if (payload.stateMsg) {
    //                 setJobStateMsg(payload.stateMsg);
    //             }
    //         });
    //     }
    // }, [jobId]);

    //성공시 팝업창으로 성공,실패 알려주기
    const onCompleted = async (data: addjobMutation) => {
        const {
            addjob: { success, message, job_id },
        } = data;
        if (success) {
            await sweetAlert.fire({
                title: '성공',
                html: `${message}${job_id}`,
                icon: 'success',
                confirmButtonText: '확인',
            });
            setJobId(`${job_id}`);
        } else {
            sweetAlert.fire({
                title: '실패',
                html: `${message}`,
                icon: 'error',
            });
        }
    };
    // 로그인체크
    async function onClickCheckLogin() {
        const confirm = await Swal.fire({
            title: '로그인',
            text: '로그인 후 이용해 주시기 바랍니다.',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: '로그인',
            cancelButtonText: '취소',
        });
        if (confirm.isConfirmed) {
            history.push('/member/login'); //router init
        }
    }

    const [addjobMutation, { data: addjobMutationResult }] = useMutation<addjobMutation, addjobMutationVariables>(
        ADDJOB_MUTATION,
        {
            onCompleted,
            //onError,
        },
    );

    //작업시작 버튼 클릭시 react-hook-form의 useForm을 통해 shopId,shopPw,prodName을 가져와서 gql addjobMutation input에 전송
    const onSubmit = () => {
        const { shopId, shopPw, prodName } = getValues();

        addjobMutation({
            variables: {
                addjobInput: {
                    shopId,
                    shopPw,
                    prodName,
                },
            },
        });
    };

    // 스크롤 이벤트
    const scrollEvent = (target: string) => {
        const targetEl = window.document.getElementById(target);

        if (targetEl !== null) {
            window.scrollTo({
                top: targetEl.offsetTop,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div id="playapiguide">
            <div id="container" className="outline-bg">
                <div className="outlineCon">
                    <dl className="contentsNav">
                        <dt>
                            <span className="eng">API</span> 개요
                        </dt>
                        <dd
                            className={check === 0 ? 'active' : ''}
                            onClick={() => {
                                scrollEvent('playapi');
                                setCheck(0);
                            }}
                        >
                            <span className="eng">PLAYAPI</span>
                        </dd>
                        <dd
                            className={check === 1 ? 'active' : ''}
                            onClick={() => {
                                scrollEvent('process');
                                setCheck(1);
                            }}
                        >
                            연동 프로세스
                        </dd>
                        <dd
                            className={check === 2 ? 'active' : ''}
                            onClick={() => {
                                scrollEvent('provision');
                                setCheck(2);
                            }}
                        >
                            제공 API
                        </dd>
                        <dd
                            className={check === 3 ? 'active' : ''}
                            onClick={() => {
                                scrollEvent('demo');
                                setCheck(3);
                            }}
                        >
                            DEMO
                        </dd>
                    </dl>
                    <div className="contentsWrap">
                        <div className="contents" id="playapi">
                            <h3 className="eng">PLAYAPI - V1(1.0.0)</h3>
                            <p>
                                PLAYAPI는 국내외 120여개의 쇼핑몰 관리자 페이지에서 제공하는 모든 기능을 표준화된 API를
                                이용해 손쉽게
                                <br />
                                자사서비스에 연동할 수 있도록 서비스합니다. <br />
                                <br />
                                신규개발 및 업데이트 유지보수의 부담없이 PLAYAPI를 이용해 빠르고 간편하게 판매채널 및
                                서비스를 확장 할 수 있습니다. <br />
                                플레이오토의 쇼핑몰 연동 Engine은 이미 6000여개의 회원사에게 보장된 기술력을 안정적으로
                                제공하고 있습니다.
                            </p>
                            <div className="api-info-list">
                                <p>프로토콜</p>
                                HTTPS
                                <p>HTTP메서드</p>
                                POST
                                <p>파라미터</p>
                                JSON 형식으로 전달합니다.
                                <p>결과(Response)</p>
                                <table className="table-basic">
                                    <thead>
                                        <tr>
                                            <th>코드</th>
                                            <th>정의</th>
                                            <th>비고</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>200</td>
                                            <td>성공</td>
                                            <td>true</td>
                                        </tr>
                                        <tr>
                                            <td>500</td>
                                            <td>실패</td>
                                            <td>false</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="contents" id="process">
                            <h3 className="eng">Process</h3>
                            <ul className="accordionList">
                                <li className="active">
                                    <div className="title">상품 API</div>
                                    <div className="desc">
                                        <img alt="" src={apiImage01} />
                                    </div>
                                </li>
                                <li>
                                    <div className="title">쇼핑몰별 추가정보(Set_data)</div>
                                    <div className="desc" style={{ paddingLeft: 30 }}>
                                        <p>
                                            상품의 공통적인 정보 외 쇼핑몰별 고유 정보는 [세트]로 분리됩니다. <br />
                                            쇼핑몰 카테고리, 출하지, 반품지 및 각 쇼핑몰에만 존재하는 항목을 상품과
                                            분리하여 템플릿화하여 작업합니다. <br />
                                            PLAYAPI는 해당 정보를 입력받을 수 있는 Front_end를 제공하지만, <br />
                                            세트 정보는 추가/수정 등 User Control이 필요한 부분으로 제휴사에 DB에 저장
                                            후 addjob 파일에 생성 시 <br />
                                            함께 전달해야 합니다.
                                        </p>
                                        <img alt="" src={apiImageSet} />
                                        <p className="colorPrimary">
                                            <span style={{ fontSize: 10, marginRight: 10 }}>▲</span> 플레이오토가
                                            제공하는 세트 form
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <div className="title">주문 API</div>
                                    <div className="desc">
                                        <img alt="" src={apiImage02} />
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="contents" id="provision">
                            <h3>
                                제공 <span className="eng">API</span>
                            </h3>
                            <p>
                                PLAYAPI에서 제공하는 기능입니다. <br />각 작업을 클릭하면 해당 API 문서로 연결됩니다.
                            </p>
                            <table className="table-basic apiFunc-table">
                                <thead>
                                    <tr>
                                        <th>구분</th>
                                        <th>작업</th>
                                        <th>상세작업</th>
                                        <th>설명</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowSpan={15}>작업 API</td>
                                        <td>
                                            {!isLoggedIn && <span onClick={onClickCheckLogin}>AddJob</span>}
                                            {isLoggedIn && <Link to="/guide/playApiOutDocs">AddJob</Link>}
                                        </td>
                                        <td></td>
                                        <td>작업 파일을 생성/등록 합니다.</td>
                                    </tr>
                                    <tr>
                                        <td rowSpan={13}>job_file</td>
                                        <td></td>
                                        <td>jop_file을 포함한 .zip파일이나 .zip파일의 URL을 입력합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=860436726"
                                                target="blank"
                                            >
                                                작업기본정보
                                            </a>
                                        </td>
                                        <td>진행할 작업구분, 쇼핑몰 로그인정보 등 기본정보를 전달합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=624774671"
                                                target="blank"
                                            >
                                                세트(Set_data)
                                            </a>
                                        </td>
                                        <td>상품정보 외 쇼핑몰 부가정보*를 생성하여 전달합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=1121686600"
                                                target="blank"
                                            >
                                                1-1 상품등록
                                            </a>
                                        </td>
                                        <td>
                                            상품정보+상품부가정보(set_data)를 전달하여 <br />
                                            신규상품 등록을 진행합니다.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=1736131854"
                                                target="blank"
                                            >
                                                1-2 상품수정
                                            </a>
                                        </td>
                                        <td>
                                            상품정보+상품부가정보(set_data)를 전달하여 <br />
                                            기등록상품 수정 작업을 진행합니다.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=187483210"
                                                target="blank"
                                            >
                                                1-3 상품판매취소
                                            </a>
                                        </td>
                                        <td>상품 판매상태를 [판매중지]로 변경합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=497052481"
                                                target="blank"
                                            >
                                                1-4 상품일시품절
                                            </a>
                                        </td>
                                        <td>상품 판매상태를 [품절]로 변경합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=712861261"
                                                target="blank"
                                            >
                                                1-5 상품품절복구
                                            </a>
                                        </td>
                                        <td>상품 판매상태를 [판매중]으로 변경하여 상품정보를 업데이트 합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=319286724"
                                                target="blank"
                                            >
                                                2-1 주문수집
                                            </a>
                                        </td>
                                        <td>
                                            쇼핑몰의 신규 주문을 가져옵니다. <br />
                                            쇼핑몰별 MISC정의 참고하여 발주데이의 <br />
                                            특정 항목을 추가 수집 할 수 있습니다.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=2016958441"
                                                target="blank"
                                            >
                                                2-2 송장전송
                                            </a>
                                        </td>
                                        <td>발주확인 된 주문에 송장번호를 전송합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=1141494396"
                                                target="blank"
                                            >
                                                2-3 주문동기화
                                            </a>
                                        </td>
                                        <td>
                                            쇼핑몰에서 변경된 주문상태를 조회하여 가져옵니다. <br />
                                            취소/반품 주문을 확인 할 수 있습니다.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=1250356340"
                                                target="blank"
                                            >
                                                3-1 문의수집
                                            </a>
                                        </td>
                                        <td>고객문의, 상품명, 긴급메세지를 수집합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a
                                                href="https://docs.google.com/spreadsheets/d/1cQrsSE0L-Ix-P3O2Ulj8V4KYwYYHjilGdWM5AssudD8/edit#gid=2052748553"
                                                target="blank"
                                            >
                                                3-2 문의전송
                                            </a>
                                        </td>
                                        <td>고객문의, 상품평, 긴급메세지 답변을 전송합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {!isLoggedIn && <span onClick={onClickCheckLogin}>getJobAttributes</span>}
                                            {isLoggedIn && <Link to="/guide/playApiOutDocs">getJobAttributes</Link>}
                                        </td>
                                        <td></td>
                                        <td>특정 작업의 상세내용을 가져옵니다.</td>
                                    </tr>
                                    <tr>
                                        <td rowSpan={3}>조회 API</td>
                                        <td>
                                            {!isLoggedIn && (
                                                <span onClick={onClickCheckLogin}>연동쇼핑몰 리스트 조회</span>
                                            )}
                                            {isLoggedIn && (
                                                <Link to="/guide/playApiOutDocs">연동쇼핑몰 리스트 조회</Link>
                                            )}
                                        </td>
                                        <td></td>
                                        <td>PLAYAPI를 이용해 연동 가능한 쇼핑몰 리스트를 조회 합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {!isLoggedIn && (
                                                <span onClick={onClickCheckLogin}>표준카테고리 리스트 조회</span>
                                            )}
                                            {isLoggedIn && (
                                                <Link to="/guide/playApiOutDocs">표준카테고리 리스트 조회</Link>
                                            )}
                                        </td>
                                        <td></td>
                                        <td>
                                            PLAYAUTO에서 제공하는 표준카테고리를 조회합니다. <br />
                                            표준카테고리는 오픈마켓(옥션, G마켓, 11번가, 인터파크, <br />
                                            스마트스토어)만 적용되며, 그 외엔 쇼핑몰 카테고리를 사용합니다.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {!isLoggedIn && (
                                                <span onClick={onClickCheckLogin}>쇼핑몰 카테고리 리스트 조회</span>
                                            )}
                                            {isLoggedIn && (
                                                <Link to="/guide/playApiOutDocs">쇼핑몰 카테고리 리스트 조회</Link>
                                            )}
                                        </td>
                                        <td></td>
                                        <td>쇼핑몰 카테고리를 실시간으로 불러와 조회 합니다.</td>
                                    </tr>
                                    <tr>
                                        <td>결과 API</td>
                                        <td>
                                            {!isLoggedIn && (
                                                <span onClick={onClickCheckLogin}>getResultAttributes</span>
                                            )}
                                            {isLoggedIn && <Link to="/guide/playApiOutDocs">getResultAttributes</Link>}
                                        </td>
                                        <td></td>
                                        <td>
                                            각 작업의 상세내용을 가져옵니다. <br />
                                            (setResultAttributes로 전달했던 데이터 포함)
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* 세트폼 */}
                        <form
                            action="http://set.playauto.co.kr/shop_group_set_make_amp_api_tab.html"
                            method="POST"
                            target="_blank"
                            id="setForm"
                        >
                            <input type="hidden" value="post" name="dataMethod" />
                            <input
                                type="hidden"
                                value='{"callbackUrl" : "callbackurl","userCode":"","sol_type":"TEST","siteCode":"A006","siteUserId":"","siteUserPw":"","number":"","siteUseretc1":"","siteUseretc2":"","siteUseretc3":"","siteUseretc4":"","siteUseretc5":"A00334890","siteUseretc6":""}'
                                name="dataInfo"
                            />
                        </form>
                        <div className="contents" id="demo">
                            <h3 className="eng">DEMO</h3>
                            <p>
                                - 아래 DEMO는 API 연동 프로세스 이해에 도움을 주고자 제공하는 기능입니다. <br />
                                - 입력된 쇼핑몰ID로 실제 작업이 진행되오니 테스트에 유의해 주시기 바랍니다. <br />
                                <br />- 자세한 코드 내용은 API 가이드 - API 문서를 참고해 주시기 바랍니다.
                                <br />- 세트 바로가기 클릭시 세트를 확인 할 수 있습니다. 하지만 입력한 값은 반영되지
                                않습니다.
                            </p>
                            <form className="demo-table">
                                <table className="table-basic">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="25%" />
                                        <col width="60%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>항목</th>
                                            <th>입력란</th>
                                            <th>Sample Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {/* <td colSpan={2}>
                                                <p style={{ transform: 'rotate(90deg)' }}>&hellip;</p>
                                            </td> */}

                                            <td>쇼핑몰</td>
                                            <td>지마켓 (고정)</td>
                                            <td rowSpan={7} style={{ textAlign: 'left', backgroundColor: 'black' }}>
                                                <span style={{ color: 'white' }}>
                                                    "domain": "발급받은 도메인",
                                                    <br /> "sol_type": "발급받은 솔루션 타입",
                                                    <br /> "sol_code": "솔루션 구별 코드 입력",
                                                    <br /> "sol_user": "TestUser",
                                                    <br /> "site_code": "A006",
                                                    <br /> "site_name": "G마켓",
                                                    <br /> "site_id":"myshopy1", <br /> <br /> "runner_type": "SERVER",{' '}
                                                    <br /> "runner_os": "WINDOWS",
                                                    <br /> "runner_env": "dev",
                                                    <br />
                                                    "result_runner_type": "SERVER",
                                                    <br /> "result_runner_os": "WINDOWS",
                                                    <br />
                                                    <br /> "job_cate": "PROD",
                                                    <br /> "job_type": "RegistProd",
                                                    <br /> "job_name": "상품등록",
                                                    <br /> "job_priority": "normal",
                                                    <br /> "job_file": "zip파일 URL 주소",
                                                    <br />
                                                    "result_callback_url": '작업결과 데이터를 받을 URL',
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>ID</td>
                                            <td>
                                                <input
                                                    name="shopId"
                                                    placeholder="G마켓 쇼핑몰 아이디"
                                                    // defaultValue="test" //고정값
                                                    ref={register({
                                                        required: true,
                                                    })} // 유효성 체크를 위한 조건을 넣어준다
                                                />
                                                {/* // 유효성 체크에 걸렸을 때 에러 문구를 설정해 준다 */}
                                                {errors.shopId && errors.shopId.type === 'required' && (
                                                    <span role="alert" style={{ color: 'red' }}>
                                                        This field is required
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>PW</td>
                                            <td>
                                                <input
                                                    name="shopPw"
                                                    type="password"
                                                    placeholder="G마켓 쇼핑몰 비밀번호"
                                                    // defaultValue="test" //고정값
                                                    ref={register({
                                                        required: true,
                                                    })} // 유효성 체크를 위한 조건을 넣어준다
                                                />
                                                {/* // 유효성 체크에 걸렸을 때 에러 문구를 설정해 준다 */}
                                                {errors.shopPw && errors.shopPw.type === 'required' && (
                                                    <span role="alert" style={{ color: 'red' }}>
                                                        This field is required
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>상품명</td>
                                            <td>
                                                <input
                                                    name="prodName"
                                                    placeholder="등록할 상품명"
                                                    // defaultValue="test" //고정값
                                                    ref={register({
                                                        required: true,
                                                    })} // 유효성 체크를 위한 조건을 넣어준다
                                                />
                                                {/* // 유효성 체크에 걸렸을 때 에러 문구를 설정해 준다 */}
                                                {errors.prodName && errors.prodName.type === 'required' && (
                                                    <span role="alert" style={{ color: 'red' }}>
                                                        This field is required
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>판매가</td>
                                            <td>50,000,000(고정)</td>
                                        </tr>
                                        <tr>
                                            <td>상품등록코드</td>
                                            <td>TestProd구매금지(고정)</td>
                                        </tr>
                                        <tr>
                                            <td>세트</td>
                                            <td>
                                                <button type="submit" form="setForm">
                                                    세트 바로가기
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="btnArea">
                                    <button type="reset">초기화</button>
                                    <button className="submitBtn" type="submit" onClick={handleSubmit(onSubmit)}>
                                        작업시작
                                    </button>
                                </div>
                            </form>
                            <div className="callbackDesc">
                                <h4 className="eng">Callback_URL</h4>
                                <div className="desc">
                                    <div style={{ fontFamily: 'noto sans KR', fontSize: 16 }}>
                                        <p>작업번호 : {jobId}</p>
                                        <p>작업 진행 상황 : {jobStateMsg}</p>
                                        <p>작업 결과 메세지 : {jobResultMsg}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlayApiGuide;
